export function getStudioBookingCtaLabel(studioName: string): string {
  return `Book at ${studioName}`;
}
